// extracted by mini-css-extract-plugin
module.exports = {"poweroceanPlus":"PoweroceanPlus_poweroceanPlus__d2kPc"};